/**
 * Country of residence for the tax statement.
 *
 * AGB 14.1: the applicable VAT rate follows the country in which the user has
 * their residence, the gross price stays the same. The backend needs that
 * country for the Stripe Tax preview, so the page asks for it - it is never
 * guessed silently into a tax amount, the amount always comes back from Stripe.
 */
export const BILLING_COUNTRIES: string[] = [
  "AT", "BE", "BG", "CH", "CY", "CZ", "DE", "DK", "EE", "ES", "FI", "FR",
  "GB", "GR", "HR", "HU", "IE", "IT", "LI", "LT", "LU", "LV", "MT", "NL",
  "NO", "PL", "PT", "RO", "SE", "SI", "SK",
];

const FALLBACK_COUNTRY = "DE";

/** Best guess from the browser locale; always changeable by the user. */
export const detectBillingCountry = (): string => {
  const languages: string[] = [
    ...(navigator.languages || []),
    navigator.language,
  ].filter(Boolean);

  for (const language of languages) {
    const region = language.split("-")[1];
    if (region && BILLING_COUNTRIES.indexOf(region.toUpperCase()) >= 0) {
      return region.toUpperCase();
    }
  }

  return FALLBACK_COUNTRY;
};

/** Localised country name, falling back to the ISO code. */
export const countryLabel = (code: string, locale: string): string => {
  try {
    const displayNames = new Intl.DisplayNames([locale], { type: "region" });
    return displayNames.of(code) || code;
  } catch {
    return code;
  }
};
